import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { Schedule } from 'shared/ui/Schedule'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useBroadcastViewContext } from 'pages/broadcasts/ui/BroadcastView/context/broadcastViewContext'

export const BroadcastSchedule = observer(() => {
  const store = useBroadcastViewContext()
  const { featureFlagsStore } = useEntitiesContext()

  useEffect(() => {
    store.broadcastScheduleStore.scheduleStore.immediatelyStore.sendingHoursStore?.setShow(
      featureFlagsStore.broadcast_restrict_hours
    )
    store.broadcastScheduleStore.scheduleStore.sendLaterStore.sendingHoursStore?.setShow(
      featureFlagsStore.broadcast_restrict_hours
    )
  }, [])

  return <Schedule scheduleStore={store.broadcastScheduleStore.scheduleStore} />
})
